module.exports = __webpack_public_path__ + "img/body-3.59cc6f31.png";